import { ReactComponent as LinesIcon } from '../../../../../assets/icons/Navegation/lineas.svg';
import { ReactComponent as SubmenuIcon } from '../../../../../assets/icons/Navegation/submenu-flecha.svg';
import { icons, triangle } from '../Styles/StylesIcons';
import GenericCollapse from './GenericCollapse';
import GenericNavListItem from './GenericNavListItem';
import GenericListItemButton from './MenuItemWithSubmenu';
import Popover from '@mui/material/Popover';

const TriangleIcon = (props) => <SubmenuIcon style={triangle} {...props} />;

const LineReportsMenu = ({
  userPermissions,
  openMenuReportsLines,
  handleClickReportsLines,
  activeStyle,
  drawerOpen,
  handlePopoverOpen,
  handlePopoverClose,
  openPopover,
  anchorEl,
}) => {
  const submenuContent = (
    <>
      {userPermissions?.includes('MANAGEMENT_REPORTS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='MANAGEMENT_REPORTS'
          to='/dashboard/manager/activations'
          title='Activaciones/Desactivaciones'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
      {userPermissions?.includes('MANAGEMENT_REPORTS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='MANAGEMENT_REPORTS'
          to='/dashboard/manager/prepaid'
          title='Recarga'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
    </>
  );

  return (
    <>
      {userPermissions?.includes('MANAGEMENT_REPORTS') && (
        <>
          <GenericListItemButton
            onClick={drawerOpen ? handleClickReportsLines : handlePopoverOpen}
            className={'layout-menu-submenu'}
            title='Líneas'
            IconComponent={(props) => <LinesIcon style={icons} {...props} />}
            openMenu={openMenuReportsLines}
          />
          {drawerOpen && (
            <GenericCollapse
              className={'layout-menu-submenu-options'}
              openMenu={openMenuReportsLines}
              userPermissions={userPermissions}
            >
              {submenuContent}
            </GenericCollapse>
          )}
          {!drawerOpen && (
            <Popover
              open={openPopover}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              onBlur={handlePopoverClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              PaperProps={{
                style: { minWidth: 220 },
                onMouseLeave: handlePopoverClose,
              }}
            >
              <div style={{ padding: 8 }}>{submenuContent}</div>
            </Popover>
          )}
        </>
      )}
    </>
  );
};

export default LineReportsMenu;
